"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Select.default;
  }
});

var _Select = _interopRequireDefault(require("./Select"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Select/index.js
// module id = 1123
// module chunks = 3